<template>
  <v-container fluid pa-0>
    <v-layout
      row
      wrap
      align-center
      class="secondary darken-1"
      justify-space-around
      style="min-height:140px"
    />
    <v-layout row wrap justify-center style="margin-top:-54px">
      <v-card class="flex xs12 sm11 shadow">
        <v-toolbar color="grey6 elevation-0" height="54px">
          <div class="di-flex align-center">
            <v-icon size="35px">backup</v-icon>
            <span class="subheading font-weight-bold mt-2 ml-2">
              {{ $t("backups") }}
            </span>
          </div>
          <v-spacer />
          <v-btn
            icon
            small
            class="shadow-md"
            @click="createBackup"
            :loading="btn_loading"
            v-if="can('add_backups')"
            color="btn_color secondary"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>

        <v-data-table
          :items="items"
          :loading="loading"
          :headers="headers"
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{ item }">
            <td>{{ item.name }}</td>
            <td>{{ item.last_modified }}</td>
            <td>{{ item.size }}</td>
            <td>
              <v-btn
                flat
                icon
                class="ma-0 pa-0"
                color="grey darken-1"
                v-if="can('view_backups')"
              >
                <v-icon @click="downloadBackup(item)">file_download</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                class="ma-0 pa-0"
                color="grey darken-1 "
                v-if="can('view_backups')"
              >
                <v-icon @click="deleteBackup(item)">mdi-delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      loading: false,
      btn_loading: false
    };
  },
  computed: {
    headers: vm => [
      {
        value: "name",
        text: vm.$t("file")
      },
      {
        text: vm.$t("date"),
        value: "last_modified"
      },
      {
        value: "size",
        text: vm.$t("size")
      },
      {
        sortable: false,
        value: "actions",
        text: vm.$t("actions")
      }
    ]
  },
  methods: {
    getData() {
      this.loading = true;
      this.axios
        .get(`backups`)
        .then(resp => {
          this.items = resp.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    deleteBackup(item) {
      let vm = this;
      this.$alert(`backups/${item.name}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    downloadBackup(item) {
      this.axios({
        method: "GET",
        url: `backups/${item.name}`,
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", item.name);
        document.body.appendChild(link);
        link.click();
      });
    },

    createBackup() {
      this.btn_loading = true;
      this.axios
        .post("backups")
        .then(() => {
          this.btn_loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("save_succeed"),
            stateType: "success",
            show: true
          });
          this.getData();
        })
        .catch(() => {
          this.btn_loading = false;
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
